import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

import Hero from '@components/Hero/Hero';

export const ClassesPageHeroHERO = styled(Hero)`
  position: relative;
  padding-bottom: var(--spacing--L);
  overflow: visible;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 705px;
    background: linear-gradient(180deg, #F5F2F0 51.06%, rgba(250, 248, 247, 0) 100%);
    pointer-events: none;
  }

  .container {
    padding: 0px;
  }
`;

export const ClassesPageHeroContentDIV = styled.div`
  position: relative;
  padding-top: 90px;
  padding-bottom: 30px;

  h1 {
    margin-bottom: 10px;
  }

  p {
    color: var(--color--charcoal-700);
  }
`;

export const ClassesPageHeroAvatarsDIV = styled.div`
  margin-top: 30px;

  > div {
    justify-content: flex-start;
  }

  h6 {
    color: var(--color--charcoal-1100);
    display: block;
    margin: 0;
  }

  ${MEDIA_QUERIES.S} {
    display: flex;
    align-items: center;

    p {
      margin-top: 0;
      margin-left: 15px;
    }
  }
`;

export const ClassesPageHeroImageDIV = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  height: 100%;
  
  .gatsby-image-wrapper {
    max-width: 632px;
    margin: 0 auto;
  }
`;
